var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoDeepBlueCitron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#01313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34866 11.3456H6.87897V8.47281H6.34866C6.05578 8.47281 5.81836 8.29474 5.81836 8.07508V7.12509C5.81836 6.90542 6.05578 6.72736 6.34866 6.72736H9.31836C9.61125 6.72736 9.84866 6.90542 9.84866 7.12509V11.3456H10.379C10.6719 11.3456 10.9093 11.5236 10.9093 11.7433V12.6933C10.9093 12.9129 10.6719 13.091 10.379 13.091H6.34866C6.05578 13.091 5.81836 12.9129 5.81836 12.6933V11.7433C5.81836 11.5236 6.05578 11.3456 6.34866 11.3456ZM8.36381 2.90918C7.30944 2.90918 6.45472 3.55022 6.45472 4.341C6.45472 5.13178 7.30944 5.77282 8.36381 5.77282C9.41819 5.77282 10.2729 5.13178 10.2729 4.341C10.2729 3.55022 9.41816 2.90918 8.36381 2.90918Z",
    fill: "#E6F972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDeepBlueCitron);
export default __webpack_public_path__ + "static/media/info-deep-blue-citron.21e3981f936136adfae17eda14b0ee22.svg";
export { ForwardRef as ReactComponent };